import store from "@/store";

class DateFormatterService {
	constructor() {}

	formattedDate(dateString, long = 1) {
		const selectedDate = new Date(dateString);
		const today = new Date(store.getters["copilot/serverLogicalDate"]);
		const yesterday = new Date(today);
		yesterday.setDate(yesterday.getDate() - 1);
		const tomorrow = new Date(today);
		tomorrow.setDate(tomorrow.getDate() + 1);

		const getMonthName = (monthIndex) => {

			let months = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
			if (long === 0){
				months = ["Ene", "Feb", "Mar", "Abr", "May", "Jun", "Jul", "Ago", "Sep", "Oct", "Nov", "Dic"];
			}

			return months[monthIndex];
		};

		const getDayName = (dayIndex) => {
			let days = ["Domingo", "Lunes", "Martes", "Miércoles", "Jueves", "Viernes", "Sábado"];

			if (long === 0){
				days = ["Dom", "Lun", "Mar", "Mié", "Jue", "Vie", "Sáb"];
			}

			return days[dayIndex];
		};

		let formattedDate = `${getDayName(selectedDate.getDay())} ${selectedDate.getDate()} de ${getMonthName(selectedDate.getMonth())}`;
		if (long === 0){
			formattedDate = `${getDayName(selectedDate.getDay(), 0)} ${selectedDate.getDate()} ${getMonthName(selectedDate.getMonth(), 0)}`;
		}


		if (selectedDate.toDateString() === today.toDateString()) {
			return `HOY ${formattedDate}`;
		} else if (selectedDate.toDateString() === yesterday.toDateString()) {
			return `AYER ${formattedDate}`;
		} else if (selectedDate.toDateString() === tomorrow.toDateString()) {
			return `MAÑANA ${formattedDate}`;
		} else {
			const dayOfWeek = getDayName(selectedDate.getDay());
			return `${dayOfWeek} ${selectedDate.getDate()} de ${getMonthName(selectedDate.getMonth())}`;
		}
	}

	formattedTime(dateString) {
		if (!dateString || typeof dateString !== "string") return "-";
		const separator = dateString.includes("T") ? "T" : " ";
		const dateTime = dateString.split(separator);
		if (!dateTime[1]) return "-";
		const [hour, minutes] = dateTime[1].substring(0, 5).split(":");
		if (!hour || !minutes) return "-";
		return `${hour}:${minutes}`;
	}

	formattedPrice(price) {
		if (isNaN(price)) {
			return price;
		}
		let formatted = parseFloat(price).toFixed(2).replace(".", ",") + "€";

		if (formatted.endsWith("00€")) {
			formatted = formatted.slice(0, -4) + "€";
		}

		if (formatted.includes(",") && formatted.endsWith("0€")) {
			formatted = formatted.slice(0, -2);
			formatted = formatted.replace(",", ",") + "€";
		}
		return formatted;
	}

	formattedPriceEmployed(price) {
		if (isNaN(price)) {
			return price;
		}
		// Aseguramos que el precio sea un número flotante y lo convertimos a texto con dos decimales
		let formatted = parseFloat(price).toFixed(2).replace(".", ",");
		return formatted;
	}

	formattedTimeChronometer(dateTimeString) {
		if (!dateTimeString) return;

		let parsedDate;

		// Caso 1: Formato "DD/MM/YYYY HH:mm:ss"
		if (dateTimeString.includes("/") && dateTimeString.includes(":")) {
			const [datePart, timePart] = dateTimeString.split(" ");
			const [day, month, year] = datePart.split("/");
			parsedDate = new Date(`${year}-${month}-${day}T${timePart}`);
		} else {
			// Caso 2: Formato "YYYY-MM-DD HH:mm:ss"
			const normalized = dateTimeString.replace(" ", "T");
			parsedDate = new Date(normalized);
		}

		if (isNaN(parsedDate.getTime())) return;

		const now = new Date();
		const difference = Math.floor((now.getTime() - parsedDate.getTime()) / 1000); // en segundos

		const hours = Math.floor(difference / 3600);
		const minutes = Math.floor((difference % 3600) / 60);
		const seconds = difference % 60;

		if (hours > 0) {
			return `${hours}h`;
		} else if (minutes > 0) {
			return `${minutes}'`;
		} else if (seconds >= 0) {
			return `Nuevo`;
		}
	}
}

export const dateFormatterService = new DateFormatterService();
